'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Container } from '@/app/components/layouts/container';
import { Section } from '@/app/components/layouts/section';
import { LifeCycleCarousel } from '@/app/components/sections/service/service-center/life-cycle/items';
import type { LifeCycleItem } from '@/app/components/sections/service/service-center/life-cycle/types';
import type { ServiceCenterOffersProps } from '@/app/components/sections/service/service-center/offers/types';
import { type TagItem, Tags } from '@/app/components/tags';
import { useRevealAnim } from '@/app/hooks/useRevealAnim';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export interface ServiceCenterLifeCycleWithDataProps extends ServiceCenterOffersProps {
  categories: TagItemWithSubItems[];
  data?: LifeCycleItem[];
  disableRevealAnim?: boolean;
}
interface TagItemWithSubItems {
  id: TagItem['id'];
  selected?: boolean;
  items?: string[];
}
export const ServiceCenterLifeCycleSection = t0 => {
  const $ = _c(62);
  const {
    id: t1,
    testId: t2,
    eventName,
    className,
    heading,
    subHeading,
    categories,
    data: t3,
    disableRevealAnim: t4
  } = t0;
  const id = t1 === undefined ? "offers" : t1;
  const testId = t2 === undefined ? "offers" : t2;
  const data = t3 === undefined ? [] : t3;
  const disableRevealAnim = t4 === undefined ? false : t4;
  const t5 = !disableRevealAnim;
  let t6;
  if ($[0] !== t5) {
    t6 = {
      defaultBaseDelay: 0.04,
      enabled: t5
    };
    $[0] = t5;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  useRevealAnim(t6);
  let t7;
  if ($[2] !== disableRevealAnim) {
    t7 = disableRevealAnim ? {} : {
      "data-revealanim-group": ""
    };
    $[2] = disableRevealAnim;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const groupAnimAttr = t7;
  let t8;
  if ($[4] !== disableRevealAnim) {
    t8 = disableRevealAnim ? {} : {
      "data-revealanim": ""
    };
    $[4] = disableRevealAnim;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const itemAnimAttr = t8;
  const dataByTitle = new Map(data.map(_temp));
  let t9;
  if ($[6] !== categories) {
    t9 = new Set(categories.flatMap(_temp2));
    $[6] = categories;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t9) {
    t10 = [...t9];
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const allTitles = t10;
  const getItemsByTitles = titles => titles.flatMap(title => dataByTitle.get(title) ?? []);
  let t11;
  if ($[10] !== allTitles || $[11] !== getItemsByTitles) {
    t11 = () => getItemsByTitles(allTitles);
    $[10] = allTitles;
    $[11] = getItemsByTitles;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const [items, setItems] = useState(t11);
  let t12;
  if ($[13] !== categories) {
    t12 = categories.map(_temp3);
    $[13] = categories;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const [selectedTags, setSelectedTags] = useState(t12);
  let t13;
  if ($[15] !== allTitles || $[16] !== getItemsByTitles || $[17] !== selectedTags) {
    t13 = updatedTags => {
      const newTags = selectedTags.map(tag => {
        if (tag.id === updatedTags.id) {
          return {
            ...tag,
            selected: !updatedTags.selected
          };
        }
        return {
          ...tag,
          selected: false
        };
      });
      setSelectedTags(newTags);
      const selectedTitles = newTags.filter(_temp4).flatMap(_temp5);
      setItems(getItemsByTitles(selectedTitles.length > 0 ? selectedTitles : allTitles));
    };
    $[15] = allTitles;
    $[16] = getItemsByTitles;
    $[17] = selectedTags;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const handleTagChange = t13;
  if (items.length === 0) {
    return null;
  }
  const t14 = `${id}-heading`;
  let t15;
  if ($[19] !== className) {
    t15 = cn("bg-silver-50 relative w-full scroll-mt-14 overflow-hidden py-7 sm:py-10 xl:py-16", className);
    $[19] = className;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  const t16 = `${testId}-section`;
  let t17;
  if ($[21] !== t16) {
    t17 = createDataAttributes({
      test: t16
    });
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  const t18 = `${id}-heading`;
  let t19;
  if ($[23] !== heading) {
    t19 = {
      __html: heading
    };
    $[23] = heading;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  const t20 = `${testId}-heading`;
  let t21;
  if ($[25] !== t20) {
    t21 = createDataAttributes({
      test: t20
    });
    $[25] = t20;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== itemAnimAttr || $[28] !== t18 || $[29] !== t19 || $[30] !== t21) {
    t22 = <h2 id={t18} data-revealanim={true} className="font-display text-h2 whitespace-pre-line text-gray-900" dangerouslySetInnerHTML={t19} {...t21} {...itemAnimAttr} />;
    $[27] = itemAnimAttr;
    $[28] = t18;
    $[29] = t19;
    $[30] = t21;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== itemAnimAttr || $[33] !== subHeading || $[34] !== testId) {
    t23 = !!subHeading && <p data-revealanim={true} className="text-body-1 where-span:text-inline-wrap text-gray-700" dangerouslySetInnerHTML={{
      __html: subHeading
    }} {...createDataAttributes({
      test: `${testId}-subHeading`
    })} {...itemAnimAttr} />;
    $[32] = itemAnimAttr;
    $[33] = subHeading;
    $[34] = testId;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== t23) {
    t24 = <div className="lg:py-3">{t23}</div>;
    $[36] = t23;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] !== t22 || $[39] !== t24) {
    t25 = <Container><div className="mb-6 grid gap-2 lg:mb-10 lg:grid-cols-2 lg:gap-6">{t22}{t24}</div></Container>;
    $[38] = t22;
    $[39] = t24;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      base: cn("font-noto-bold h-10 min-w-fit py-2 before:border-2 first:ml-4 last:mr-4 md:first:ml-10 xl:first:ml-0"),
      selected: cn("before:hidden")
    };
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== selectedTags) {
    t27 = selectedTags.map(_temp6);
    $[42] = selectedTags;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] !== handleTagChange || $[45] !== t27) {
    t28 = <Container size="desktop-only" maxWidth="none" className="xl:mx-auto xl:max-w-320"><Tags type="selecting" className="scrollbar-hidden mb-6 flex-nowrap overflow-auto lg:overflow-hidden xl:mb-10" tagCustomStyled={t26} noIcon={true} tags={t27} onChange={handleTagChange} /></Container>;
    $[44] = handleTagChange;
    $[45] = t27;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] !== eventName || $[48] !== items || $[49] !== testId) {
    t29 = <Container><LifeCycleCarousel items={items} testId={testId} eventName={eventName} /></Container>;
    $[47] = eventName;
    $[48] = items;
    $[49] = testId;
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  let t30;
  if ($[51] !== t28 || $[52] !== t29) {
    t30 = <div data-revealanim={true}>{t28}{t29}</div>;
    $[51] = t28;
    $[52] = t29;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] !== groupAnimAttr || $[55] !== id || $[56] !== t14 || $[57] !== t15 || $[58] !== t17 || $[59] !== t25 || $[60] !== t30) {
    t31 = <Section id={id} aria-labelledby={t14} size="none" className={t15} {...t17} {...groupAnimAttr}>{t25}{t30}</Section>;
    $[54] = groupAnimAttr;
    $[55] = id;
    $[56] = t14;
    $[57] = t15;
    $[58] = t17;
    $[59] = t25;
    $[60] = t30;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  return t31;
};
function _temp(item) {
  return [item.title, item];
}
function _temp2(category) {
  return category.items ?? [];
}
function _temp3(item_0) {
  return {
    id: item_0.id,
    label: item_0.id,
    selected: false,
    items: item_0.items
  };
}
function _temp4(tag_0) {
  return tag_0.selected;
}
function _temp5(tag_1) {
  return tag_1.items ?? [];
}
function _temp6(tag_2) {
  return {
    id: tag_2.id,
    label: tag_2.id,
    selected: tag_2.selected
  };
}